import React, { useEffect, useState } from 'react';

// project-imports
import { _setBgColor } from '../../utils';
import { useUserContext } from '../../context/user_context';
import { InstructorCourseSliderParams } from '../../utils/script';
import { GoogleAnalyticsEnum, pageView, triggerFunction } from '../../utils/google-analytics';
import SEO from '../../common/SEO';
import Skill from '../../components/progressbar/ProgressbarItem';
import Avatar from 'react-avatar';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import { formatViews } from '../../utils/course';

// third-party
import { useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import TrackVisibility from 'react-on-screen';
import UserDetailTab from './UserDetailTab';
import ReusableWidget from '../../components/reusable/widgets/ReusableWidget';
import { useGalleryContext } from '../../context/gallery_context';
import FsLightbox from 'fslightbox-react';
import GalleryDrawer from '../../components/our-gallery/GalleryDrawer';
import EBookWidget from "../../components/reusable/widgets/EBookWidget";
import UserProfilePicUpload from './UserProfilePicUpload';

// Reading Enviroment Variable Start 
const SALESFORCE_COURSE_DOMAIN = process.env.REACT_APP_SALESFORCE_COURSE_DOMAIN;
// Reading Enviroment Variable End

const UserDetail = () => {

    // Property initialization
    const { id } = useParams();

    // React navigation initialization
    const navigate = useNavigate();

    //Reading state from store
    const { isLoading } = useUserContext();
    const { loginData } = useSelector((item) => item.user);
    const blogData = useSelector(state => state.blog.blogs);
    const courseData = useSelector(state => state.courses.courses);
    const courseUserReaction = useSelector(data => data.courses.courseAllUserReactions) || [];
    const blogUserReaction = useSelector(data => data.blog.blogAllUserReactions) || [];
    const { popularVideos, popularShorts, popularLiveVideos, lastWeekTrendingVideos, latestVideos, galleryLoading } = useGalleryContext();

    // Constant variable 
    // Extracting login user's data
    const teamMember = loginData && loginData?.data && loginData?.data;

    const instructorNameForGA = GoogleAnalyticsEnum.USER_DETAILS + " " + teamMember?.userFullName;

    const [toggler, setToggler] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    // Extracting the blogs liked by Particular user
    const blogs = blogData && Array.isArray(blogData) && blogData.filter(blog => {
        return Array.isArray(blog.likes) && blog.likes.some(like => (like.userId === id && like.isLiked));
    });

    const noBlogsFoundMsg = "You have no liked blogs yet. Explore our articles and click the heart icon to save your favorites here!";

    // Extracting course liked by particular user
    const courses = courseData && Array.isArray(courseData) && courseData.filter(course => {
        return Array.isArray(course.likes) && course.likes.some(like => (like.userId === id && like.isLiked));
    });

    const noCoursesFoundMsg = "You have no liked courses yet. Explore our articles and click the heart icon to save your favorites here!";
    const formattedViews = formatViews(courses.quizzes || 0, { decimalPlaces: 2 });

    // Extracting course reactions added by particular user
    const filteredCourseUserReaction = courseUserReaction && Array.isArray(courseUserReaction) && courseUserReaction.filter(reactions => {
        return Array.isArray(reactions.userCourseReactions) && reactions.userCourseReactions.some(reaction => (reaction.userId === id));
    });

    // Extracting blogs reactions added by particular user
    const filteredBlogUserReaction = blogUserReaction && Array.isArray(blogUserReaction) && blogUserReaction.filter(reactions => {
        return Array.isArray(reactions.userBlogReactions) && reactions.userBlogReactions.some(reaction => (reaction.userId === id));
    });

    // Finding total counts of reactions added in blogs and courses
    const totalUserReactionCount = (filteredCourseUserReaction.length || 0) + (filteredBlogUserReaction.length || 0);

    let instructorCourseSliderParams = { ...InstructorCourseSliderParams, slidesToShow: courses.length < 2 ? courses.length : 2 }
    let instructorBlogSliderParams = { ...InstructorCourseSliderParams, slidesToShow: blogs.length < 2 ? blogs.length : 2 }

    const latestVideosData = latestVideos && latestVideos?.length && latestVideos ? latestVideos : [];

    const handleVideoToggle = (url) => {
        try {
            setVideoUrl(url);
            setToggler(!toggler);
        } catch (error) { }
    };

    const handleOpenDrawer = (data) => {
        try {
            setOpenDrawer(true);
            setSelectedItem(data);
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.SF_TUTORIALS_DETAIL_VIEW,
            );
        } catch (error) {
            console.log(
                "49 : HomeFourBlog : Error in handleOpenDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };

    const handleHideDrawer = () => {
        try {
            setOpenDrawer(false);
        } catch (error) {
            console.log(
                "60 : HomeFourBlog : Error in handleHideDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };

    useEffect(() => {
        try {
            if (!isLoading && !teamMember) {
                navigate('/', { replace: true });
            }
        } catch (error) {
            console.log("Error while checking logged user:", error);
            throw error;
        }
    }, [teamMember, isLoading]);


    return (
        <>
            {pageView(window.location.pathname, instructorNameForGA)}

            <SEO title={`Longswitch Academy user ${teamMember?.userFullName}`} /> {/* Set SEO title */}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="My Profile" // Breadcrumb title 
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="My Profile"
                />
                <div className="edu-instructor-profile-area edu-section-gap bg-color-white pb-150">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-4 pr-sm--55">
                                <div className="instructor-profile-left p-20">
                                    <div className="inner">

                                        <UserProfilePicUpload />

                                        <div className="content">
                                            <h5 className="title">{teamMember?.userFullName}</h5>
                                            <div className="contact-with-info">
                                                <p><span>Email:</span> <a href={`mailto:${teamMember?.userId}`}>{teamMember?.userId}</a></p>
                                                <p><span>User Name:</span> {teamMember?.userName}</p>
                                            </div>
                                            <div className="contact-btn">
                                                <Link to="/" className="edu-btn">Back to Home
                                                    <i className="icon-arrow-right-line-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <BannerOne extraClass="mt--20" /> */}

                                <EBookWidget classes="mt--20 d-none d-lg-flex" />


                                <ReusableWidget data={latestVideosData} title="Latest Videos" href="https://www.youtube.com/@LongswitchAcademy/videos" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} classes="d-none d-lg-block mt--20" />

                            </div>

                            <div className="col-lg-8">
                                <div className="instructor-profile-right">
                                    <div className="inner text-center">
                                        <div className="section-title text-start">
                                            <span className="pre-title">About You</span>
                                            <h3 className="title">Hello, {teamMember?.userFullName}</h3>
                                            <p className="description mt--20">This Dashboard displays your personal details available at Longswitch Academy Website. You can track your activity with courses and blogs here. </p>
                                        </div>

                                        {teamMember?.experience && teamMember?.experience.length > 0 &&
                                            <div className="edu-skill-style mt--65">
                                                <div className="section-title text-start mb--30">
                                                    <span className="pre-title">Skillset</span>
                                                    <h3 className="title">Courses Progress</h3>
                                                </div>
                                                <div className="rbt-progress-style-1 row g-5">
                                                    {teamMember?.experience.map((progress, i) => (
                                                        <div className="col-lg-6" key={i}>
                                                            <TrackVisibility
                                                                once
                                                                className="single-progress"
                                                            >
                                                                {({ isVisible }) => isVisible &&
                                                                    isVisible ? <Skill progress={progress} isVisible={isVisible} /> : ''}
                                                            </TrackVisibility>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        }

                                        {/* <div className="course-statistic-wrapper bg-color-primary ptb--30 mt--65 mb--10 radius-small">
                                            <div className="row align-items-center g-5">
                                                <div className="col-lg-4 col-md-6 col-12 line-separator">
                                                    <div className="course-statistic text-center">
                                                        <div className="inner">
                                                            <TrackVisibility once>
                                                                {({ isVisible }) => isVisible && <span className="total"><CountUp end={blogs.length || 0} duration={1} delay={.1} start={0} /></span>

                                                                }
                                                            </TrackVisibility>
                                                            <TrackVisibility once>
                                                                {({ isVisible }) => isVisible && <span className="total"><CountUp end={blogs.length || 0} duration={1} delay={.1} start={0} decimals={1} /></span>

                                                                }
                                                                <p>Blogs Liked</p>
                                                            </TrackVisibility>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-12 line-separator">
                                                    <div className="course-statistic text-center">
                                                        <div className="inner">
                                                            <TrackVisibility once>
                                                                {({ isVisible }) => isVisible && <span className="total"><CountUp end={courses.length || 0} duration={1} delay={.1} start={0} /></span>

                                                                }
                                                            </TrackVisibility>
                                                            <TrackVisibility once>
                                                                {({ isVisible }) => isVisible && <span className="total"><CountUp end={courses.length || 0} duration={1} delay={.1} start={0} decimals={1} /></span>

                                                                }
                                                                <p>Courses Liked</p>
                                                            </TrackVisibility>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-12 line-separator">
                                                    <div className="course-statistic text-center">
                                                        <div className="inner">
                                                            <TrackVisibility once>
                                                                {({ isVisible }) => isVisible && <span className="total"><CountUp end={totalUserReactionCount || 0} duration={1} delay={.1} start={0} /></span>

                                                                }
                                                            </TrackVisibility>
                                                            <TrackVisibility once>
                                                                {({ isVisible }) => isVisible && <span className="total"><CountUp end={totalUserReactionCount || 0} duration={1} delay={.1} start={0} decimals={1} /></span>

                                                                }
                                                                <p>Response Added</p>
                                                            </TrackVisibility>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        <UserDetailTab />
                                    </div>
                                </div>
                            </div>

                            <EBookWidget classes="mt--20 d-flex d-lg-none" />

                            <ReusableWidget data={latestVideosData} title="Latest Videos" href="https://www.youtube.com/@LongswitchAcademy/videos" onVideoToggle={handleVideoToggle} onOpenDrawer={handleOpenDrawer} classes="d-block d-lg-none mt--20" />

                        </div>
                    </div>
                </div>
                <div className="video-lightbox-wrapper">
                    <FsLightbox
                        toggler={toggler}
                        sources={[videoUrl]}
                        maxYoutubeVideoDimensions={
                            { width: 1920, height: 1080 }
                        }
                    />
                </div>

                {selectedItem && (
                    <GalleryDrawer
                        show={openDrawer}
                        classes={null}
                        onClose={handleHideDrawer}
                        data={selectedItem}
                        onVideoToggle={handleVideoToggle}
                        title={"Salesforce Tutorials Info"}
                        isLoading={galleryLoading}
                    />
                )}
            </Layout>
        </>
    )
}
export default UserDetail;